import escape from "lodash/escape"

// Rewrite the alt of the <img> carrying the given asset id in a cached HTML string, escaping the
// new altText. Uses a replacer FUNCTION (not a string) so $-sequences in altText — e.g. "$1", "$&",
// "$$" from money/regex-like alt text — are not interpreted as replacement patterns, which would
// corrupt the mirror (SC 1.1.1 — keep the full alt intact).
export function rewriteImageAlt(
  html: string,
  assetRecordId: string,
  altText: string
): string {
  const regex = new RegExp(
    `(<img[^>]*?)alt="[^"]*"([^>]*id="${assetRecordId}"[^>]*>)`,
    "g"
  )
  return html.replace(
    regex,
    (_match, beforeAlt, afterAlt) =>
      `${beforeAlt}alt="${escape(altText)}"${afterAlt}`
  )
}
